import { newsInfo } from "../news/newsSettings";

export var homeInfo = {
    navigation: {
        items: [
            {
                text: "About Digital",
                link: "#aboutUsSection"
            },
            {
                text: "Cloud Solutions",
                link: "/cloud-solutions"
            },
            {
                text: "Customers",
                link: "/testimonials"
            }
        ]
    },
    landingCarousel: {
        id: "landingCarousel",
        images: [
            "/img/landing/119860183-m-normal-none.jpg",
            "/img/landing/138163225-m-normal-none.jpg",
            "/img/landing/155652305-l-normal-none.jpg",
            "/img/landing/187307411-l-normal-none.jpg",
            "/img/landing/201189087-m-normal-none.jpg",
            "/img/landing/pv-roof-installation.jpg",
            "/img/landing/roof-drain-city-background.jpg",
            "/img/landing/workers-in-elevator.jpg"
        ],
        takeRandomImageCount: 3,
        messages: [
            {
                title: "Mission-Based Technology for Building Management Services",
                description: "Innovative solutions to manage roofs, façades, paving, and elevators with precision and efficiency.",
                button: {
                    text: "Get Started With Free Trial",
                    type: "contact-us",
                    link: "#"
                }
            }
        ],
        sideBox: {
            title: "Recent News",
            items: [
                {
                    image: "/img/users/dfc-admin-bw.png",
                    text: newsInfo.items[0].title,
                    date: newsInfo.items[0].date,
                    type: newsInfo.items[0].type,
                    shortDescription: newsInfo.items[0].shortDescription,
                    link: {
                        text: newsInfo.items[0].type === 'event' ? "View Details" : "6 min read",
                        link: newsInfo.items[0].type === 'event' ? "#" : newsInfo.items[0].url,
                    }
                }
            ],
            link: {
                text: "View All",
                link: "#news"
            }
        }
    },
    fmPro: {
        head: "Technology for <span class=\"text-highlight\">Mission Based Services</span>",
        description: "Digital provides time-saving programs for managing  critical building systems. Improve long-term outcomes using specialized technology designed for capturing details required for analysis. If you are outsourcing services our FMPro™  solution offers a proven option to consider.",
        cards: [
            {
                id: "roofManagment",
                images: [
                    "/img/fmpro/green-roof.jpg",
                    "/img/fmpro/repair-roof.jpg",
                    "/img/fmpro/roof-hvac.jpg"
                ],
                title: "Roof Management",
                text: "Advanced roof management solutions to optimize maintenance schedules, track performance, and ensure compliance."
            },
            {
                id: "facadeAssesment",
                images: [
                    "/img/fmpro/airport-wall-detail.jpg",
                    "/img/fmpro/workers-wall-climb.jpg",
                    "/img/fmpro/wall-colorful.jpg"
                ],
                title: "Façade Assessment",
                text: "Comprehensive façade evaluation tools for structural integrity, code compliance, and proactive maintenance."
            },
            {
                id: "pavingManagement",
                images: [
                    "/img/fmpro/parking.png",
                    "/img/fmpro/broken-asphalt.png",
                    "/img/fmpro/fixing-asphalt.png"
                ],
                title: "Paving Management",
                text: "Efficient paving system management for accurate inspections, maintenance planning, and longevity."
            },
            {
                id: "elevatorManagement",
                images: [
                    "/img/fmpro/fix-escalator.jpg",
                    "/img/fmpro/fix-escalator.jpg",
                    "/img/fmpro/fix-escalator.jpg"
                ],
                title: "VT Equipment Management",
                text: "VT Equipment ManagementEnsure smooth and safe vertical transportation with our elevator management solutions."
            }
        ]
    },
    customerSay: {
        modalTitle: "Customer Say",
    },
    ourSolutions: {
        ourSolutionDescription: "<b>Optimizing Management of Critical Building Systems</b> The idea was that technology would work for you—not the other way around. So why are your teams losing the important details, constantly tasked to confirm as-built system documentation, and investing time in organizing condition reporting and budgets? Digital Facilities technology solutions start with a workflow design to save time as you manage specialized building areas. Then provides efficient technology tools for streamlining data entry, maintaining records, preparing condition assessments, and building institutional knowledge with Analytics. Our solutions are proven over twenty years of deployments for K-12 schools and universities. Public agencies, REITS, and Commercial property owners.",
        startTrialDescription: "Let us show you around a live demonstration, experience our solution capabilities, to get started Send a request. Let us show you around a live demonstration, experience our solution capabilities, to get started Send a request <br><b>Contact Us</b>. Annual plans start at <span class=\"text-highlight\">$1,895.00</span>.",
    },
    buildingSystemModules: {
        modules: [
            {
                image: "/img/building-system-modules/roof-pro-brochure.jpg",
                brochureUrl: "/media/Brochures2025/RoofPro.25.1.pdf",
                url: "/cloud-solutions/roof-pro",
                videoUrl: "https://youtu.be/PY3PKScudps",
                title: "RoofPro™",
                text: "RoofPro™ is an innovative platform designed for seamless organization of commercial roofing systems and components, offering advanced data management for consultants and professional roofing service providers."
            },
            {
                image: "/img/building-system-modules/wall-pro-brochure.jpg",
                brochureUrl: "/media/Brochures2025/WallPro.25.1.pdf",
                url: "/cloud-solutions/wall-pro",
                videoUrl: "https://youtu.be/aYSNwrGk6QM",
                title: "WallPro™",
                text: "WallPro™ is an innovative platform for managing commercial wall systems, offering a digital solution with seamless field access for all stakeholders. Designed to document intricate vertical building structures, it ensures precise as-built data for inspections, code compliance, and scheduled maintenance."
            },
            {
                image: "/img/building-system-modules/pave-pro-brochure.jpg",
                brochureUrl: "/media/Brochures2025/PavePro.25.1.pdf",
                url: "/cloud-solutions/pave-pro",
                videoUrl: "https://youtu.be/cXv4O3OMsWU",
                title: "PavePro™",
                text: "PavePro™ has a unique design for documenting each unique paving area. Use as a standalone or in conjunction with other asset areas. An innovative design that enables quick inspections and, when required, detailed paving asset management. Users can adapt the program to analyze paving for reporting to internal and external business missions. "
            },
            {
                image: "/img/building-system-modules/vt-pro-brochure.jpg",
                brochureUrl: "/media/Brochures2025/VTPro.25.1.pdf",
                url: "/cloud-solutions/vt-pro",
                videoUrl: "https://youtu.be/fQ_hIIhs3LI",
                title: "VTPro™",
                text: "VTPro™ is an advanced solution for managing elevators and people-moving systems. It provides precise as-built data to support investigations, scheduled repairs, and maintenance. Designed for compliance, it ensures inspections meet regulatory standards efficiently."
            }
        ]
    },
    aboutUs: {
        slides: [
            {
                title: "Company Foundation",
                description: "Digital Facilities Corporation (DFC) is a privately held technology company headquartered in Boston, MA. Established in 2002, DFC has built a strong reputation for delivering innovative solutions that help organizations assess and manage complex building systems.",
                image: "/img/about-us/building-1.jpg"
            },
            {
                title: "Industry Leadership",
                description: "As an industry leader, DFC specializes in developing advanced technology platforms that streamline the assessment, monitoring, and management of specialized building systems. These solutions enhance operational efficiency, improve system performance, and ensure compliance with industry standards.",
                image: "/img/about-us/charting-2.jpg"
            },
            {
                title: "Trusted Solutions",
                description: "DFC's technology is trusted by building owners, consultants, and contractors across the U.S. and Canada. Serving industries such as education, healthcare, retail, manufacturing, military, transportation, and energy production, its solutions help manage more than 20,000 buildings in both public and private sectors.",
                image: "/img/about-us/trusted-solutions-3.png"
            }
        ]
    },
    newsAndHighlights: {
    },
    publishedArticles: {

    }
};